import {
  ApiStatus,
  AppState
} from './app-state.types';
import { ChatModeType } from '../../pages/ai-chat/ai-chat.constants';

export const DefaultAppState: AppState = {
  courseSectionId: null,
  currentCourse: null,
  evolveUser: null,
  crosswalkApiStatus: ApiStatus.IDLE,
  featureFlagsGrouped: null,
  messages: null,
  pendingRequestCount: 0,
  userId: null,
  eolsUser: null,
  appLinkCookies: null,
  registeredToken: null,
  userRole: null,
  appLinkData: null,
  abTestFlavors: null,
  osmosisTokenDto: null,
  cookieCheckComplete: false,
  ecrId: null,
  tokenIsbns: null,
  selectedIsbnMap: {},
  chats: null,
  entitlements: null,
  isLoading: false,
  inProgressPostProcessJobIds: [],
  showLoader: false,
  activeChatId: null,
  ipAddress: null,
  isSidebarOpen: true,
  isPanelOpen: false,
  enableAdminOverride: false,
  chatUserRole: null,
  pageContext: '',
  chatModeType: ChatModeType.DEFAULT_STUDY_MODE,
};
